import { ORDER_STATUSES } from '@/constants'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { OrderInterface, OrderShortType } from '@/types'

import cn from './OrderStatus.module.scss'

function OrderStatus({
  order,
}: {
  order: OrderInterface['orderModel'] | OrderShortType
}) {
  const { userId } = useUserInfoStore((state) => state)

  const rawData = localStorage.getItem('userUnviewedOrders')
  const userUnviewedOrders = rawData ? JSON.parse(rawData) : {}

  const isUnviewed =
    userId && userUnviewedOrders[userId]?.includes(String(order.code))

  return (
    <div className={cn.block}>
      <div
        className={[
          cn.statusIndicator,
          cn[order.orderStatus.split('_').join('').toLowerCase()],
        ].join(' ')}
      ></div>
      <span>{ORDER_STATUSES[order.orderStatus]}</span>
      {isUnviewed && <div className={cn.indicator}></div>}
    </div>
  )
}

export default OrderStatus
